function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.1429 18.8538H16.5V9.74665C16.5 5.96719 13.7063 2.84397 10.0714 2.32433V1.28237C10.0714 0.690402 9.59196 0.210938 9 0.210938C8.40804 0.210938 7.92857 0.690402 7.92857 1.28237V2.32433C4.29375 2.84397 1.5 5.96719 1.5 9.74665V18.8538H0.857143C0.383036 18.8538 0 19.2368 0 19.7109V20.5681C0 20.6859 0.0964286 20.7824 0.214286 20.7824H6C6 22.4377 7.34464 23.7824 9 23.7824C10.6554 23.7824 12 22.4377 12 20.7824H17.7857C17.9036 20.7824 18 20.6859 18 20.5681V19.7109C18 19.2368 17.617 18.8538 17.1429 18.8538ZM9 22.0681C8.29018 22.0681 7.71429 21.4922 7.71429 20.7824H10.2857C10.2857 21.4922 9.70982 22.0681 9 22.0681ZM3.42857 18.8538V9.74665C3.42857 8.25737 4.00714 6.85915 5.05982 5.80647C6.1125 4.75379 7.51072 4.17522 9 4.17522C10.4893 4.17522 11.8875 4.75379 12.9402 5.80647C13.9929 6.85915 14.5714 8.25737 14.5714 9.74665V18.8538H3.42857Z",
  fill: "black",
  fillOpacity: 0.65
});

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.620914b8.svg";
export { ForwardRef as ReactComponent };